import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import VueFilters from 'vue2-filters/src/index'
import Vuelidate from 'vuelidate'
import VueMoment from 'vue-moment'
import VueLoadProgress from 'vue-load-progress'
import momentLocale from 'moment/locale/pt-br'
import VueToastr2 from 'vue-toastr-2/src/toastr.min'
import VueSweetAlert from 'vue-sweetalert'
import router from './router'
import store from '@/store/index'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.min'
import TheContainer from './the-container.vue'
import SidebarMenu from './plugins/sidebar-menu'
import eventBus from './plugins/event-bus'
import Base64 from './plugins/base64'
import CPF_CNPJ from './plugins/cpfCnpj'
import datePicker from 'vue-bootstrap-datetimepicker/dist/vue-bootstrap-datetimepicker.min'
import money from 'v-money'
import VTooltip from 'v-tooltip'
import Chartkick from 'vue-chartkick'
import VueClipboard from 'vue-clipboard2'
import $ from 'jquery'
import VueTheMask from 'vue-the-mask'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import Paginate from 'vuejs-paginate'

VueClipboard.config.autoSetContainer = true
Vue.config.productionTip = true
Vue.use(VueFilters)
Vue.use(SidebarMenu)
Vue.use(Chartkick)
Vue.use(VueClipboard)
Vue.use(VTooltip)
Vue.use(VueLoadProgress)
Vue.use(Vuelidate)
Vue.use(VueSweetAlert)
Vue.use(BootstrapVue)
Vue.use(VueMoment, {
  momentLocale
})
Vue.use(datePicker)
Vue.use(eventBus)
Vue.prototype.$toastr = VueToastr2
Vue.prototype.$base64 = Base64
Vue.prototype.$cpfCnpj = CPF_CNPJ
Vue.prototype.$script = require('./features/whatsapp/js/script')
Vue.prototype.$cpfCnpj = CPF_CNPJ
Vue.prototype.$ = $
Vue.use(money, {precision: 4})
Vue.use(VueTheMask)
Vue.component('paginate', Paginate)

library.add(faUserSecret)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)

window.$ = window.jQuery = require('jquery')

Vue.prototype.flot = require('flot')
Vue.prototype.flotresize = require('flot/source/jquery.flot.resize')
Vue.prototype.flotcategories = require('flot/source/jquery.flot.categories')
Vue.prototype.flotstack = require('flot/source/jquery.flot.stack')
Vue.prototype.flottime = require('flot/source/jquery.flot.time')
Vue.prototype.flotpie = require('flot/source/jquery.flot.pie')
Vue.use(new VueSocketIO({
  debug: false,
  connection: process.env.API_URL_SOCKET,
  vuex: {
    store
  },
  options: {
    path: '/message/socket.io'
  }
}))

window.VueCalendarLang = (lang) => {
  return {
    daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
    limit: 'Limite máximo de ({{limit}} itens).',
    loading: 'Carregado...',
    minLength: 'Tamanho mínimo',
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    notSelected: 'Nenhum selecionado',
    required: 'Obrigatório',
    search: 'Procurar'
  }
}


new Vue({
  el: '#app',
  router,
  store,
  template: '<the-container/>',
  components: { TheContainer }
})



// WEBPACK FOOTER //
// ./src/main.js